"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TextInput = require("./TextInput");
Object.keys(_TextInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TextInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TextInput[key];
    }
  });
});